/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	  (0, _module.stepSlider)();
	  (0, _module.visibleButton)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visibleButton = exports.stepSlider = exports.anchorLink = void 0;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var stepSlider = function stepSlider() {
	  var _$$slick;
	
	  $('.idx-Slider_Inner').slick((_$$slick = {
	    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
	    accessibility: true,
	    // 自動再生。trueで自動再生される。
	    autoplay: false,
	    // 自動再生や左右の矢印でスライドするスピード
	    speed: 500,
	    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
	    pauseOnHover: true,
	    // 自動再生時にドットにマウスオンで一時停止するかどうか
	    pauseOnDotsHover: true,
	    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
	    cssEase: 'ease',
	    // 画像下のドット（ページ送り）を表示
	    dots: true,
	    // ドットのclass名をつける
	    dotsClass: 'slick-dots',
	    // ドラッグができるかどうか
	    draggable: true,
	    // 切り替え時のフェードイン設定。trueでon
	    fade: false,
	    // 左右の次へ、前へボタンを表示するかどうか
	    arrows: true,
	    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
	    infinite: false,
	    // 最初のスライダーの位置
	    initialSlide: 0,
	    // 画像の遅延表示。‘ondemand’or'progressive'
	    lazyLoad: 'ondemand'
	  }, _defineProperty(_$$slick, "pauseOnHover", true), _defineProperty(_$$slick, "slidesToShow", 1), _defineProperty(_$$slick, "slidesToScroll", 1), _defineProperty(_$$slick, "swipe", true), _defineProperty(_$$slick, "vertical", false), _defineProperty(_$$slick, "centerMode", true), _defineProperty(_$$slick, "variableWidth", true), _defineProperty(_$$slick, "prevArrow", '<a class="slick-prev" href="#"></a>'), _defineProperty(_$$slick, "nextArrow", '<a class="slick-next" href="#"></a>'), _$$slick));
	}; // ------------------------------------------------------------------------
	// visibleButton
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.stepSlider = stepSlider;
	
	var visibleButton = function visibleButton() {
	  var targetButton = document.querySelector('.sw-Top');
	  var targetHeight = 100;
	  window.addEventListener('scroll', function () {
	    var scrollHeight = window.pageYOffset;
	
	    if (scrollHeight > targetHeight) {
	      targetButton.classList.remove('is-Hidden');
	    } else {
	      targetButton.classList.add('is-Hidden');
	    }
	  });
	};
	
	exports.visibleButton = visibleButton;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js